import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const IconButton = ({isBusy, styleName, onClick, children}) => (
  <div className="IconButton">
    <button
      className={classNames("IconButton__button", {
        "IconButton--disabled": isBusy,
      })}
      onClick={onClick}
    >
      <span className="IconButton__contents">
        <div
          className={classNames("IconButton__icon", styleName, {
            "IconButton--disabled": isBusy,
          })}
        />
        {children}
      </span>
    </button>
  </div>
);

IconButton.propTypes = {
  isBusy: PropTypes.bool.isRequired,
  styleName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isBusy: state.busy.isBusy,
});

export { IconButton };
export default connect(mapStateToProps)(IconButton);



// WEBPACK FOOTER //
// ./src/components/IconButton.js